import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Select } from 'next/components/ui';
import { getPermissionValueForUser } from 'helpers/account-management';
import {
  ADMINISTRATOR_OPTION,
  PUBLISHER_OPTION,
  EDITOR_OPTION,
} from 'constants/accountManagement/permissions';
import UpgradeTag from 'components/Common/UpgradeTag';

const OptionDescription = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export default function UserPermissionsSelectInput({
  accountUsers,
  disabled,
  hasEditorPermissionsRole,
  onSelectPermission,
  user,
  ...rest
}) {
  const updatePermission = ({ value }) => {
    onSelectPermission({ userId: user?.id, role: value });
  };

  const options = [
    {
      label: ADMINISTRATOR_OPTION.label,
      description: ADMINISTRATOR_OPTION.permissionDescription,
      value: 'ACCOUNT_ADMIN',
    },
    {
      label: PUBLISHER_OPTION.label,
      description: PUBLISHER_OPTION.permissionDescription,
      value: 'PUBLISHER',
    },
    {
      label: EDITOR_OPTION.label,
      description: (
        <OptionDescription>
          {EDITOR_OPTION.permissionDescription}{' '}
          {!hasEditorPermissionsRole && (
            <UpgradeTag label="Upgrade" icon="magic" />
          )}
        </OptionDescription>
      ),
      value: 'EDITOR',
      isDisabled: !hasEditorPermissionsRole,
    },
  ];

  const props = {
    ...rest,
  };

  if (user) {
    const permission = getPermissionValueForUser({ user, accountUsers });
    const selected = options.find(({ value }) => value === permission);

    props.value = selected;
  }

  return (
    <Select
      open
      disabled={disabled}
      options={options}
      onChange={updatePermission}
      menuPlacement="auto"
      portal
      {...props}
    />
  );
}

UserPermissionsSelectInput.propTypes = {
  onSelectPermission: PropTypes.func,
  user: PropTypes.shape({
    id: PropTypes.string,
  }),
  accountUsers: PropTypes.objectOf({
    createdAt: PropTypes.number,
    enabledAt: PropTypes.number,
    id: PropTypes.string,
    isAccountAdmin: PropTypes.bool,
    role: PropTypes.string,
    status: PropTypes.string,
  }),
  disabled: PropTypes.bool,
  hasEditorPermissionsRole: PropTypes.bool,
};
